import type { bankClp } from '../general/types'
import banksData from '../../data/banksClpData.json'

export class bankListClpService {
  async getBanksList(): Promise<{ data: bankClp[] }> {
    const banks = banksData.data
    return { data: banks }
  }
}
